import { FC } from "react";

/**
 * Icon linh kiện vẽ đúng nét của bản thiết kế (viewBox 24, nét 1.8, đầu tròn),
 * thay cho ảnh linh kiện: mỗi danh mục 1 icon và 1 màu (xem PART_CATEGORIES).
 */
const make = (d: string): FC<{ className?: string }> => {
  function PartIcon({ className }: { className?: string }) {
    return (
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        className={className}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={d} />
      </svg>
    );
  }

  return PartIcon;
};

export const IcPartBoard = make("M4 4h16v16H4z M8 8h4v4H8z M15 8h2 M15 11h2 M8 15h9");
export const IcPartChip = make(
  "M7 7h10v10H7z M10 10h4v4h-4z M9 3v4 M15 3v4 M9 17v4 M15 17v4 M3 9h4 M3 15h4 M17 9h4 M17 15h4"
);
export const IcPartVga = make("M2 7h18v10H2z M20 10h2 M8 12a2.5 2.5 0 1 0 0-.01 M15 12a2.5 2.5 0 1 0 0-.01 M5 17v2");
export const IcPartRam = make("M3 8h18v8H3z M6 16v3 M10 16v3 M14 16v3 M18 16v3 M7 11h2 M11 11h2 M15 11h2");
export const IcPartDisk = make("M5 3h14v18H5z M9 7h6 M12 17h.01");
export const IcPartBolt = make("M13 3L5 13h6l-1 8 8-10h-6z");
export const IcPartBox = make("M3 13h5l1.5 3h5L16 13h5 M5.5 5h13L21 13v6H3v-6z");
export const IcPartMonitor = make("M3 4h18v12H3z M8 20h8 M12 16v4");
